import React, { useEffect, useMemo, useState } from 'react'
import { Badge, Button, Dropdown, Form, Input, Select } from 'antd'
import EmptyContent from '../../components/EmptyContent'
import { inject, observer } from 'mobx-react'
import { SearchOutlined } from '@ant-design/icons'
import { Tuning2OutlineIcon } from '../../components/AppIcon'
import { checkValidFormFieldValue } from '../../utils/helper'

const { Option } = Select
const styleIconSearch = {
  opacity: '0.5',
  position: 'absolute',
  right: 5,
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 9,
}

const AdvanceFilterBlock = props => {
  const { queryParams, handleChangeParams } = props
  const [showFilter, setShowFilter] = useState(false)

  const [form] = Form.useForm()
  const values = Form.useWatch([], form)

  useEffect(() => form.resetFields(), [])

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(queryParams?.title)) count++
    if (hasValue(queryParams?.bussiness_doc_type)) count++
    if (queryParams?.status && queryParams?.status?.length > 0) count++
    return count
  }, [queryParams])

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  const onFinish = values => {
    const params = {
      title: values.title ? values.title.trim() : null,
      bussiness_doc_type: values.bussiness_doc_type
        ? values.bussiness_doc_type.trim()
        : null,
      status: values.status ? values.status : null,
    }
    handleChangeParams(params)
    onToggleFilter()
  }

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form
            scrollToFirstError={true}
            form={form}
            layout={'vertical'}
            onFinish={onFinish}
            initialValues={{ title: queryParams?.title }}>
            <div className="form-elements">
              <Form.Item label={'Trích yếu'} name={'title'}>
                <Input
                  placeholder={'Nhập trích yếu văn bản'}
                  prefix={<SearchOutlined style={styleIconSearch} />}
                />
              </Form.Item>
              <Form.Item
                label={'Loại nghiệp vụ văn bản'}
                name={'bussiness_doc_type'}>
                <Select
                  allowClear
                  notFoundContent={<EmptyContent />}
                  placeholder={'Chọn loại nghiệp vụ xử lý văn bản'}>
                  <Option value={'0'}>Tạo văn bản mới</Option>
                  <Option value={'2'}>Cập nhật văn bản đã gửi</Option>
                  <Option value={'1'}>Thu hồi văn bản đã gửi</Option>
                  <Option value={'3'}>Thay thế văn bản đã gửi</Option>
                </Select>
              </Form.Item>
              <Form.Item label={'Trạng thái'} name={'status'}>
                <Select
                  allowClear
                  mode="multiple"
                  notFoundContent={<EmptyContent />}
                  placeholder={'Chọn trạng thái văn bản'}>
                  <Option value={'00'}>Tạo văn bản mới</Option>
                  <Option value={'null'}>Đã gửi</Option>
                  <Option value={'01'}>Đã đến</Option>
                  <Option value={'02'}>Từ chối tiếp nhận</Option>
                  <Option value={'03'}>Đã tiếp nhận văn bản</Option>
                  <Option value={'04'}>Phân công xử lý</Option>
                  <Option value={'05'}>Đang xử lý</Option>
                  <Option value={'06'}>Hoàn thành</Option>
                  <Option value={'13'}>Yêu cầu lấy lại văn bản</Option>
                  <Option value={'15'}>Đồng ý lấy lại, cập nhật văn bản</Option>
                  <Option value={'16'}>
                    Từ chối lấy lại, cập nhật văn bản
                  </Option>
                  <Option value={'100'}>Văn bản bị thu hồi</Option>
                  <Option value={'200'}>Văn bản bị cập nhật</Option>
                  <Option value={'300'}>Văn bản bị thay thế</Option>
                </Select>
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  onToggleFilter()
                  handleChangeParams({}, true)
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

AdvanceFilterBlock.propTypes = {}

export default inject()(observer(AdvanceFilterBlock))
